// src/apis/authServiceInitializer.js

let authService;
let isAuthServiceInitialized = false;

export const initializeAuthService = async () => {
  if (isAuthServiceInitialized) return;

  const authProvider = process.env.REACT_APP_AUTH_PROVIDER;

  switch (authProvider) {
    case 'firebase':
      const { default: FirebaseAuthService } = await import('services/FirebaseAuthService');
      authService = new FirebaseAuthService();
      break;
      
    /* case 'aws':
      const { default: AWSAuthService } = await import('services/AWSAuthService');
      authService = new AWSAuthService();
      break; */

    default:
      throw new Error(`Unsupported auth provider: ${authProvider}`);
  }

  isAuthServiceInitialized = true;
};

export const getAuthService = () => {
  if (!authService) {
    throw new Error('AuthService has not been initialized. Call initializeAuthService first.');
  }
  return authService;
};
